import React, { FC, useState } from 'react';

import usePrefix from 'utils/usePrefix';
import { ResqlExpertSubmissionListItem, AdminSubmissionFilters } from 'utils/api/resqlexpert.d';

import Button from 'components/Button';
import ExpertFilterModal from 'components/Modals/ExpertFilterModal';
import SubmissionsListBase from 'components/ResqlExpert/SubmissionsList';
import { ButtonDotStyled } from '../../../components/Button/styles';

interface Props {
  items: ResqlExpertSubmissionListItem[];
  hasMore: boolean;
  loading: boolean;
  error: Error | null;
  loadMore: () => void;
  retry: () => void;
  selectedId?: number;
  setSelectedId: (id: number) => void;
  query: string;
  setQuery: (q: string) => void;
  filters: AdminSubmissionFilters;
  setFilters: (filters: AdminSubmissionFilters) => void;
}

const SubmissionsList: FC<Props> = ({ filters, setFilters, ...rest }) => {
  const t = usePrefix('ResqlExpert');
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  return (
    <SubmissionsListBase
      {...rest}
      headerAction={
        <Button
          onClick={() => setIsFilterOpen(true)}
          label={t('cta_filter')}
          color="link"
          noPadding
        >
          {Object.keys(filters).length > 0 ? <ButtonDotStyled aria-label="" /> : null}
        </Button>
      }
      footer={
        <ExpertFilterModal
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          filters={filters}
          onApply={setFilters}
        />
      }
    />
  );
};

export default SubmissionsList;
